<template>

    <div>
        <el-upload
            :action="uploadUrl"
            :headers="photoUploadRequestHeaders"
            :show-file-list="false"
            :on-success="handleImageSuccess"
            :on-error="handleImageUploadError"
            :before-upload="beforeImageUpload"
            drag>
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <div v-else>
                <i class="mdi mdi-shape-rectangle-plus image-upload-icon"></i>
                <p class="mb-2">{{emptyViewTitle}}</p>
            </div>
        </el-upload>
    </div>

</template>

<script>

    export default {

        props: ["uploadUrl", "defaultImageUrl"],

        data () {
            return {
                imageUrl: this.defaultImageUrl,
                photoUploadRequestHeaders: window.axios.defaults.headers.common,
                emptyViewTitle: "Upload your logo here"
            };
        },

        watch: {
            defaultImageUrl (newVal) {
                this.imageUrl = newVal;
            }
        },

        methods: {

            handleImageUploadError (error, file, fileList) {
                this.emptyViewTitle = "Upload your logo here";
                toastr.error("Photo upload failed! Please try again.");
            },

            handleImageSuccess (res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
            },

            beforeImageUpload (file) {
                const isValidImageType = ["image/jpeg", "image/png"].includes(file.type);
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isValidImageType) {
                    toastr.error("Only jpeg and png files allowed!");
                }

                if (!isLt2M) {
                    toastr.error("Image size can not exceed 2MB!");
                }

                if (isValidImageType && isLt2M) {
                    this.imageUrl = "";
                    this.emptyViewTitle = "Uploading...";
                    return true;
                }

                return false;
            }

        }

    };

</script>

<style>

    .el-upload-dragger:hover {
        border: 2px solid #f2f7f8;
    }

    .el-upload:focus .el-upload-dragger {
        border: 2px solid #f2f7f8;
    }

    .el-upload-dragger.is-dragover {
        border: 2px solid #f2f7f8 !important;
    }

    .el-upload-dragger {
        background-color: #fff;
        border: 1px solid #fff;
        border-radius: 6px;
        box-sizing: border-box;
        max-height: 178px;
        width: auto;
        height: auto;
        min-height: 100px;
        min-width: 200px;
        text-align: center;
        position: relative;
        overflow: hidden;
    }

    .el-upload--picture-card:hover, .el-upload:focus {
        border: 2px solid #f2f7f8;
    }

    .avatar {
        max-height: 178px;
        width: auto;
        height: auto;
        display: block;
    }

    .image-upload-icon {
        font-size: 56px;
    }

</style>
